import { useEffect } from "react";
import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import Hot from "./components/Hot";
import TimelineSection from "./components/TimelineSection";
import Guide from "./components/Guide";
import Faq from "./components/Faq";
import Reputation from "./components/Reputation";
import Contact from "./components/Contact";
import Footer from "./components/Footer";
import BackToTop from "./components/BackToTop";
import { faqs, timeline, siteContact } from "@/mocks/gossip";

const SITE_URL = "https://palnet.cn/";

function injectJsonLd(key: string, data: object) {
  const script = document.createElement("script");
  script.type = "application/ld+json";
  script.id = key;
  script.text = JSON.stringify(data);
  document.head.appendChild(script);
}

export default function Home() {
  useEffect(() => {
    const org = {
      "@context": "https://schema.org",
      "@type": "Organization",
      name: "本月大瓜时间线",
      url: SITE_URL,
      email: siteContact.email,
      slogan: siteContact.slogan,
      description: "专注按时间线整理本月大瓜经过与全程脉络的文娱内容站点。",
    };
    const website = {
      "@context": "https://schema.org",
      "@type": "WebSite",
      name: "本月大瓜时间线",
      url: SITE_URL,
      inLanguage: "zh-CN",
      publisher: { "@type": "Organization", name: "本月大瓜时间线" },
    };
    const webpage = {
      "@context": "https://schema.org",
      "@type": "WebPage",
      name: "本月大瓜时间线｜九月吃瓜全程脉络回顾站",
      url: SITE_URL,
      inLanguage: "zh-CN",
      about: "本月大瓜时间线与全程脉络回顾",
    };
    const itemList = {
      "@context": "https://schema.org",
      "@type": "ItemList",
      name: "本月大瓜时间线",
      itemListElement: timeline.map((t, i) => ({
        "@type": "ListItem",
        position: i + 1,
        name: `${t.date} · ${t.title}`,
        description: t.summary,
      })),
    };
    const faq = {
      "@context": "https://schema.org",
      "@type": "FAQPage",
      mainEntity: faqs.map((f) => ({
        "@type": "Question",
        name: f.q,
        acceptedAnswer: { "@type": "Answer", text: f.a },
      })),
    };

    injectJsonLd("json-org", org);
    injectJsonLd("json-website", website);
    injectJsonLd("json-webpage", webpage);
    injectJsonLd("json-itemlist", itemList);
    injectJsonLd("json-faq", faq);

    return () => {
      ["json-org", "json-website", "json-webpage", "json-itemlist", "json-faq"].forEach((k) => {
        document.getElementById(k)?.remove();
      });
    };
  }, []);

  return (
    <>
      <Navbar />
      <main>
        <Hero />
        <Hot />
        <TimelineSection />
        <Guide />
        <Faq />
        <Reputation />
        <Contact />
      </main>
      <Footer />
      <BackToTop />
    </>
  );
}